import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { exhaustMap, map, catchError } from 'rxjs/operators';
import { HiveApplicationService } from 'src/app/applications/hive-application.service';
import * as ApplicationsActions from './applications.actions';

@Injectable()
export class ApplicationsEffects {
  applicationsList$ = createEffect(() =>
    this.actions.pipe(
      ofType(ApplicationsActions.fetchHiveApplications),
      exhaustMap(() =>
        this.hiveApplicationService.getItems().pipe(
          map((response) =>
            ApplicationsActions.getHiveApplicationsSuccess({
              applications: response,
            })
          ),
          catchError((err) => of(ApplicationsActions.getHiveApplicationsError({ error: err })))
        )
      )
    )
  );

  constructor(
    private actions: Actions,
    private hiveApplicationService: HiveApplicationService,
  ) {
  }
}
